interface FilterChipsProps {
  options: { label: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterChips({ options, value, onChange }: FilterChipsProps) {
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto no-scrollbar px-4 py-2">
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`text-xs px-3 py-1.5 rounded-full font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
            value === opt.value
              ? 'bg-foreground-900 text-background-50'
              : 'bg-background-100 text-foreground-500 hover:bg-background-200'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}